export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_POST':
         {
            return {
               ...state,
               postPayload: action.payload
            };
         }
      default:
         return state;
   }
}
